{
  "de": {
    "aiCategories": {
      "categories": {
        "all": "Alle",
        "character": "Personas",
        "communication": "Verwaltung",
        "content": "Differenzieren",
        "featured": "Neu",
        "feedback": "Auswerten",
        "inspiration": "Inspirieren",
        "material": "Materialien",
        "model": "Sprachmodell",
        "null": "Nicht kategorisiert",
        "planning": "Planung",
        "plugin": "Plugin",
        "pupils": "Schüler*innen",
        "teachers": "Lehrkräfte",
        "document_qa": "Dokumenten-Assistent",
        "undefined": "Nicht kategorisiert"
      },
      "personaCategories": {
        "famousMen": "Berühmte Männer",
        "famousWomen": "Berühmte Frauen",
        "funny": "Lustige fiktive Figuren"
      },
      "subcategories": {
        "pupils": {
          "exercises": "Übungen und Lernhelfer*innen",
          "inspiration": "Inspiration und Kreatives",
          "roleplay": "Chatbots für Rollenspiele"
        },
        "teachers": {
          "feedback": "Feedback und Bewertung",
          "information": "Information und Orientierung",
          "inspiration": "Inspiration und Kreatives",
          "material": "Material und Aufgaben",
          "administration": "Schulverwaltung und Organisation",
          "planning": "Unterrichtsplanung und Organisation"
        }
      }
    }
  }
}
